// extracted by mini-css-extract-plugin
module.exports = {"currentLink":"styles--currentLink--51Abk","activeLink":"styles--activeLink--TmYFM","midScreen":"styles--midScreen--38KYn"};